"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const tariffCalculator = (0, graphql_tag_1.default)`
  query tariff_calculator {
    tariff {
      calculator {
        limits {
          limitName
          limitType
          options {
            name
            cost
            amount
            recommended
          }
          visible
          disabled
        }
        status
        errorMessage
        currentLimits {
          limitType
          availableAmount
          spentAmount
          remainAmount
        }
      }
    }
  }
`;
exports.default = tariffCalculator;